import React from 'react';

const PageHeader = ({ title, description, backgroundImage }) => {
  return (
    <div className="relative bg-gray-900">
      {/* Background Image Overlay */}
      {backgroundImage && (
        <div className="absolute inset-0">
          <img
            className="w-full h-full object-cover"
            src={backgroundImage}
            alt=""
          />
          <div className="absolute inset-0 bg-gray-900 opacity-75"></div>
        </div>
      )}

      {/* Content */}
      <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {description && (
          <p className="mt-6 text-xl text-gray-300 max-w-3xl">
            {description}
          </p>
        )}
      </div>

      {/* Bottom Wave Pattern (optional decorative element) */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          className="w-full h-8 sm:h-12 text-gray-50 fill-current"
          viewBox="0 0 1440 64"
          preserveAspectRatio="none"
        >
          <path d="M0,0 C480,64 960,64 1440,0 L1440,64 L0,64 Z"></path>
        </svg>
      </div>
    </div>
  );
};

export default PageHeader; 